import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {selectAllJourneys} from '@/state/selectors/consumerLoyalty';

export const useJourney = (journeyId?: string) => {
    const journeys = useSelector(selectAllJourneys);

    return useMemo(() => {
        return journeyId ? journeys.find((j) => j.journeyId === journeyId) : undefined;
    }, [journeyId, journeys]);
};
